$( document ).on("turbo:load", initStructureLightIdModal);

function initStructureLightIdModal() {
  if ($('#light-id-modal').length > 0) {
    $('[data-function="existing-light-id-list"]').hide();
    $('a[data-function="existing-light-id"]').click(function(e){
      e.preventDefault();
      $('[data-function="existing-light-id-list"]').show();
    });
  }
}
